import styled from "styled-components";
import { useMap } from "../../hooks/useMap";

export const GoogleMap: React.FC = () => {
  const {} = useMap();

  return (
    <GoogleMapContainer>
      <MapContainer id="googleMap"></MapContainer>
    </GoogleMapContainer>
  );
};

const GoogleMapContainer = styled.div`
  margin-bottom: 80px;
  object-fit: contain;
  width: 100%;
  height: 320px;
`;

const MapContainer = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 320px;
`;
